export const PROPERTIES_SELECTION = {
  ALL_PROPERTIES: 'ALL_PROPERTIES',
  SELECTED_PROPERTIES: 'SELECTED_PROPERTIES',
} as const;
